import CalendarMonth from '@mui/icons-material/CalendarMonth';
import InputAdornment from '@mui/material/InputAdornment';
import { TextInput } from '@src/common/components/TextInput';
import type { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';

interface DateInputProps extends Omit<
  ComponentProps<typeof TextInput>,
  'onChange' | 'onBlur'
> {
  inputRef: React.RefObject<HTMLDivElement>;
  onCalendarClick: () => void;
  endAdornment?: JSX.Element;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur: () => void;
  placeholder?: string;
}

export const DateInput: React.FC<DateInputProps> = ({
  inputRef,
  onCalendarClick,
  endAdornment,
  onChange,
  onBlur,
  placeholder,
  ...props
}) => {
  const { t } = useTranslation();

  const effectiveEndAdornment = props.readOnly ? (
    endAdornment
  ) : (
    <InputAdornment position="end">
      {endAdornment}
      <CalendarMonth
        onClick={onCalendarClick}
        titleAccess={t('openCalendar')}
        style={{ cursor: 'pointer' }}
      />
    </InputAdornment>
  );

  return (
    <TextInput
      {...props}
      ref={inputRef}
      onChange={onChange}
      onBlur={onBlur}
      placeholder={placeholder}
      readOnly={props.readOnly}
      slotProps={{
        input: {
          readOnly: props.readOnly,
          endAdornment: effectiveEndAdornment,
        },
      }}
    />
  );
};
